import { NavLink } from 'react-router-dom'
import styled, { css } from 'styled-components'

export const linkStyles = css`
  color: #fff;
  text-align: center;
  font-feature-settings: 'ss01' on;
  font-family: 'Space Grotesk';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;

  text-align: center;
  display: flex;
  align-items: center;
  position: relative;

  :hover {
    span {
      color: ${({ theme }) => theme.colors.brandPrimary};
    }
  }
`

export const Link = styled(NavLink)`
  ${linkStyles}
`

export const LinkContainer = styled.div<{ isActiveLink: boolean }>`
  ${({ isActiveLink }) =>
    isActiveLink &&
    css`
      ${Link}, span,
      a {
        :after {
          content: '';
          position: absolute;
          left: 0;
          bottom: -8px;
          width: 100%;
          background: radial-gradient(
              145.7% 145.7% at 100% -45.7%,
              #3f5dff 0%,
              #f4ed0c 100%
            )
            /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
          height: 2px;
        }
      }
    `}
  :hover {
    span {
      color: ${({ theme }) => theme.colors.brandPrimary};
    }
  }
`
